import * as React from "react";
import type { SVGProps } from "react";
const SvgCigaretteSlashed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.71 16.293-4-4-10-10a.996.996 0 1 0-1.41 1.41l8.29 8.29H4c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h12.59l3.71 3.71a.97.97 0 0 0 .71.29c.26 0 .51-.1.71-.29a.996.996 0 0 0 0-1.41l-4-4zM4 14.003h3v2H4zm5 2v-2h3.59l2 2zm9-7.5c.55 0 1 .45 1 1v.5c0 .55.45 1 1 1s1-.45 1-1v-.5c0-1.65-1.35-3-3-3-.55 0-1-.45-1-1v-.5c0-.55-.45-1-1-1s-1 .45-1 1v.5c0 1.65 1.35 3 3 3m-1 3.5h3v-.01c1.1 0 2 .9 2 2v2c0 .54-.21 1.05-.6 1.43a.98.98 0 0 1-.7.29c-.25 0-.51-.1-.71-.3a.996.996 0 0 1 .01-1.41v-2h-3c-.55 0-1-.45-1-1s.45-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCigaretteSlashed;
